<template lang="pug">
  div
    slot(:product="product")
</template>

<script>
  import vueProductSvc from '@services/vueProductSvc';
  import vueColorPlusSvc from '@services/vueColorPlusSvc';

  export default {
    name: 'Product',

    props: {
      productId: {
        type: [String, Number]
      },

      productCode: {
        type: String
      },

      productUrlKey: {
        type: String
      },

      isColorPlus: {
        type: Boolean, default: false
      },
    },
    data() {
      return {
        product: null,
        loadingProduct: false,
        productError: null
      };
    },
    watch: {
      isColorPlus() {
        this.fetchProduct();
      },
      productId() {
        this.fetchProduct();
      },
      productCode() {
        this.fetchProduct();
      },
      productUrlKey() {
        this.fetchProduct();
      }
    },
    created() {
      this.fetchProduct();
    },
    methods: {
      async fetchProduct() {
        this.loadingProduct = true;
        this.productError = null;
        try {
          if (this.isColorPlus) {
            const colorPlus = await vueColorPlusSvc.getColorPlusProduct({productCode: this.productCode});
            if (colorPlus.data && colorPlus.data.exactMatch) {
              this.product = colorPlus.data.product;
              return;
            }
          }
          if (this.productId) {
            const res = await vueProductSvc.getProductById({id: this.productId});
            this.product = res.data;
          } else if (this.productCode) {
            this.product = await vueProductSvc.getProductByCode({code: this.productCode});
          } else {
            this.product = await vueProductSvc.getProductByUrlKey({urlKey: this.productUrlKey});
          }
        } catch (error) {
          this.productError = error;
        } finally {
          this.loadingProduct = false;
        }
      }
    }
  };
</script>
